import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/AdminLayout";
import { api } from "../../lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/customers");
      setUsers(data);
      setLoading(false);
    })();
  }, []);
  return (
    <AdminLayout>
      <div className="eyebrow mb-2">Customers</div>
      <h1 className="font-display text-4xl font-bold tracking-tight">Accounts</h1>

      <div className="mt-6 rounded-2xl border border-line bg-white overflow-hidden">
        {loading ? (
          <div className="px-6 py-10 text-sm text-inkSoft">Loading…</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-widest text-inkSoft border-b border-line bg-surfaceAlt/40">
                <th className="px-6 py-4 font-medium">Name</th>
                <th className="px-6 py-4 font-medium">Email</th>
                <th className="px-6 py-4 font-medium">Auth</th>
                <th className="px-6 py-4 font-medium">Orders</th>
                <th className="px-6 py-4 font-medium">Last active</th>
                <th className="px-6 py-4 font-medium">Admin</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.user_id} className="border-b border-line last:border-0" data-testid={`customer-row-${u.user_id}`}>
                  <td className="px-6 py-4 font-medium">{u.name}</td>
                  <td className="px-6 py-4 text-inkSoft">{u.email}</td>
                  <td className="px-6 py-4 font-mono text-xs">{u.auth_provider}</td>
                  <td className="px-6 py-4 font-mono">{u.orders_count}</td>
                  <td className="px-6 py-4 text-xs text-inkSoft" data-testid={`customer-last-login-${u.user_id}`}>
                    {u.last_login_at ? (
                      <>
                        <div>{new Date(u.last_login_at).toLocaleString()}</div>
                        <div className="text-[10px] font-mono opacity-70">{u.last_login_method || "—"}{u.last_login_ip ? ` · ${u.last_login_ip}` : ""}</div>
                      </>
                    ) : "—"}
                  </td>
                  <td className="px-6 py-4">{u.is_admin ? <span className="tag tag-accent">Admin</span> : <span className="text-inkSoft text-xs">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AdminLayout>
  );
}
